import { createContext } from 'react';

const CalendarAvailabilityContext = createContext<{
  isCalendarPending: boolean;
  isCalendarError: boolean;
  calendarData: any;
  calendarError: any;
}>({
  isCalendarPending: true,
  isCalendarError: false,
  calendarData: null,
  calendarError: null
});

export default CalendarAvailabilityContext;
